import {getAxiosInstance} from "../../../np-rest/rest";
import {snackActions} from "../../../sc-utilities/SnackBar";

export const fetchRaspberryEraseStationsCount = (filterData) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let countRes = await rest.post("/raspberry-erase-station/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data && countRes.data.message ? countRes.data.message : "Cannot fetch Work Dongle data."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch Work Dongle data."}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const fetchRaspberryEraseStationsList = (filterData) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let countRes = await rest.post("/raspberry-erase-station/list", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data && countRes.data.message ? countRes.data.message : "Cannot fetch Work Dongle data."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch Work Dongle data."}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const bulkDeleteRaspberryEraseStations = (params) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post("/raspberry-erase-station/bulk-delete", params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully deleted Work Dongles.`,
                    options: {
                        variant: "success",
                    },
                });
                return;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete Work Dongles."
                }`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const revokeRaspberryEraseStation = (data) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            const res = await rest.post("/raspberry-erase-station/revoke", data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot revoke Work Dongle."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}

export const fetchRaspberryEraseStation = (filterData) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            const res = await rest.post("/raspberry-erase-station/load", filterData);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data && res.data.message ? res.data.message : "Cannot fetch Work Dongle."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch Work Dongle."}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const updateRaspberryEraseStation = (filterData) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let countRes = await rest.post("/raspberry-erase-station/save", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data && countRes.data.message ? countRes.data.message : "Cannot update Work Dongle."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot update Work Dongle."}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const updatePresets = (filterData) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let countRes = await rest.post("/raspberry-erase-station/update-config", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return { status: true };
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data && countRes.data.message ? countRes.data.message : "Cannot update Work Dongle config."}`,
                options: {
                    variant: "warning",
                },
            });
            return { status: false };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot update Work Dongle config."}`,
                options: {
                    variant: "error",
                },
            });
            return { status: false };
        }
    };
};

export const startSession = (data) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let res = await rest.post("/raspberry-erase-station/start-erasure", data);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data && res.data.message ? res.data.message : "Cannot start Work Dongle session."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot start Work Dongle session."}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const abortSession = (data) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let res = await rest.post("/raspberry-erase-station/abort-erasure", data);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data && res.data.message ? res.data.message : "Cannot abort Work Dongle session."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot abort Work Dongle session."}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const getDebugLogs = (data) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            const res = await rest.post("/raspberry-erase-station/get-debug-log", data);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data && res.data.message ? res.data.message : "Cannot get Work Dongle debug logs."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot get Work Dongle debug logs."}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const resetRaspberryEraseStation = (data) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            const res = await rest.post("/raspberry-erase-station/reset-details", data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot reset Work Dongle."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}